import request from './base'

export default {
  /**
   * 添加
   * params: {
   *  dto: {
   *   authorityId: null, 1表示添加管理员，传2表示添加编辑，传3表示添加助理
   *   mobile: 11111,
   *   pwd: 111,
   *   realName: ''
   *  }
   * }
   */
  addBackEndMaster: (commit, payload, mutation) => {
    let options = request.getOptions('/customer/addBackEndMaster', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 启用 & 恢复
   * params: {
   *  dto: {
   *    customerId: 1,
   *    status: 2  2表示恢复，传9表示禁用
   *  }
   * }
   */
  enableOrDelete: (commit, payload, mutation) => {
    let options = request.getOptions('/customer/enableOrDelete', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 查询
   * params: {
   *  pageSize: 10,
   *  pageNum: 0,
   *  dto: {
   *    authorityId: 1  1表示查管理员，传2表示查编辑，传3表示查助理
   *  }
   * }
   */
  queryList: (commit, payload, mutation) => {
    let options = request.getOptions('/customer/query', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 添加账号
   * params: {
   *  dto: {
   *    type: 3, //2 代理机构，3 会员用户
   *    mobile: '1111',
   *    pwd: '1111',
   *    partnerId: '1111',
   *    realName: ''
   *  }
   * }
   */
  addAccount: (commit, payload, mutation) => {
    let options = request.getOptions('/customer/addAccount', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 获取机构
   * params:{
   *  pageNum: 0,
   *  pageSize: 10000,
   *  dto: {
   *    partnerType: 2,
   *    like: ''
   *  }
   * }
   */
  queryPartnerListToShow: (commit, payload, mutation) => {
    let options = request.getOptions('/partner/queryPartnerListToShowByName', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 查询账户
   * params:{
   *  pageNum: 0,
   *  pageSize: 10,
   *  dto: {
   *    type: 2, //2 代理机构，3 会员用户  9 已禁用
   *    partnerName: '', 关键字
   *    beginTime: '2019-01-01',
   *    endTime: '2019-04-12'
   *  }
   * }
   */
  queryAccount: (commit, payload, mutation) => {
    let options = request.getOptions('/customer/queryAccount', payload)
    return request.post(commit, options, mutation)
  }
}



// WEBPACK FOOTER //
// ./src/services/authority.js